module.exports = __webpack_public_path__ + "static/media/add_btn.77d75dda.svg";